const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-TemplatedEntityLookup',
			DefaultInputExtensions: [ 'Pict-Input-TemplatedEntityLookup' ],
			Template: /*HTML*/`
			<!-- InputType TemplatedEntityLookup {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							value="">
						<div
							id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.ControlAttr~}
						></div>
					</p>
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-TemplatedEntityLookup',
			DefaultInputExtensions: [ 'Pict-Input-TemplatedEntityLookup' ],
			Template: /*HTML*/`
			<!-- InputType TemplatedEntityLookup', {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="hidden"
									tabindex="-1"
									{~D:Record.Macro.InputFullProperties~}
									value="">
								<div
									id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
									class="input is-static"
									{~D:Record.Macro.ControlAttr~}
								></div>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-TemplatedEntityLookup',
			DefaultInputExtensions: [ 'Pict-Input-TemplatedEntityLookup' ],
			Template: /*HTML-Partial*/`
			<!-- DataType Text {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control">
				<input
					id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				 	type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InformaryTabular~}
					`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-TemplatedEntityLookup',
			Template: /*HTML-Partial*/`
					value="">
				<div
					id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					class="input is-static"
					{~D:Record.Macro.ControlAttr~}
					{~D:Record.Macro.HTMLName~}
				></div>
			</p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-TemplatedEntityLookup',
			DefaultInputExtensions: [ 'Pict-Input-TemplatedEntityLookup' ],
			Template: /*HTML*/`
			<!-- InputType TemplatedEntityLookup {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							value="">
						<div
							id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.ControlAttr~}
						></div>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-TemplatedEntityLookup',
			DefaultInputExtensions: [ 'Pict-Input-TemplatedEntityLookup' ],
			Template: /*HTML*/`
			<!-- InputType TemplatedEntityLookup {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="hidden"
									tabindex="-1"
									{~D:Record.Macro.InputFullProperties~}
									value="">
								<div
									id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
									type="text"
									class="input is-static"
									{~D:Record.Macro.ControlAttr~}
									readonly
									value=""
								></div>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-TemplatedEntityLookup',
			DefaultInputExtensions: [ 'Pict-Input-TemplatedEntityLookup' ],
			Template: /*HTML-Partial*/`
			<!-- InputType TemplatedEntityLookup {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control">
				<input
					id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-TemplatedEntityLookup',
			Template: /*HTML-Partial*/`
					value="">
				<div
					id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					class="input is-static"
					{~D:Record.Macro.ControlAttr~}
					{~D:Record.Macro.HTMLName~}
				></div>
			</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-TemplatedEntityLookup',
			DefaultInputExtensions: [ 'Pict-Input-TemplatedEntityLookup' ],
			Template: /*HTML*/`
			<!-- InputType TemplatedEntityLookup {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							value="">
						<div
							id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.ControlAttr~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-TemplatedEntityLookup',
			DefaultInputExtensions: [ 'Pict-Input-TemplatedEntityLookup' ],
			Template: /*HTML*/`
			<!-- InputType TemplatedEntityLookup {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="control">
							<input
								id="{~D:Record.Macro.RawHTMLID~}"
								type="hidden"
								tabindex="-1"
								{~D:Record.Macro.InputFullProperties~}
								value="">
							<div
								id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
								class="input is-static"
								{~D:Record.Macro.ControlAttr~}
							></div>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-TemplatedEntityLookup',
			DefaultInputExtensions: [ 'Pict-Input-TemplatedEntityLookup' ],
			Template: /*HTML-Partial*/`
			<!-- InputType TemplatedEntityLookup {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InformaryTabular~}
				`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-TemplatedEntityLookup',
			Template: /*HTML-Partial*/`
				value="">
			<div
				id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;
